/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import { computed } from '@vue/composition-api';
import { usePrefixClass } from '../hooks/useConfig.js';
import '../config-provider/useConfig.js';
import '../config-provider/context.js';
import 'lodash/merge';
import 'lodash/mergeWith';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '@babel/runtime/helpers/typeof';
import '../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../_chunks/dep-9849f16c.js';
import '../config-provider/type.js';

var BASE_COMPONENT_NAME = "color-picker";
var useBaseClassName = function useBaseClassName(className) {
  var baseClassName = usePrefixClass(BASE_COMPONENT_NAME);
  return computed(function () {
    return className ? "".concat(baseClassName.value, "-").concat(className) : baseClassName.value;
  });
};

export { useBaseClassName as default, useBaseClassName };
//# sourceMappingURL=hooks.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/color-picker/hooks.js
// module id = null
// module chunks = 